module.exports = __webpack_public_path__ + "assets/ef369a23e525e3ab353daf2073c97c3d.png";